import { Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import show from "../../../api/auth/customers/show";
import { useParams } from "react-router-dom";
import PageLoading from "../../../components/layout/PageLoading";
import index from "../../../api/auth/customers/orders";
import ExpandableOrderCard from "../../../components/displays/orders/ExpandableOrderCard";

export default function Customer() {
  const { id } = useParams();

  const [customer, setCustomer] = useState({});
  const [customerOrders, setCustomerOrders] = useState([]);

  useEffect(() => {
    show(id, (response) => {
      setCustomer(response);
    });
    index(id, (response) => {
      setCustomerOrders(response);
    });
  }, []);

  if(!customer) return <PageLoading />;

  return (
    <Stack>
      <Stack>
        <Typography variant="h4">
          {customer.full_name}
        </Typography>
      </Stack>
      <Stack>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <Stack>
              <Typography variant="h6">Past orders</Typography>
            </Stack>
            <Stack>
              {customerOrders.map((order) => (
                <ExpandableOrderCard key={order.id} order={order} />
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}